import { ControlStyleOptionsType } from '@/pages/Onboarding/options/ControlStyle/types';

export const CONTROL_STYLE_OPTIONS: ControlStyleOptionsType = [
  {
    id: 'cold_and_cruel',
    title: 'Cold and cruel',
  },
  {
    id: 'seductive_but_strict',
    title: 'Seductive but strict',
  },
  {
    id: 'playful_with_a_whip',
    title: 'Playful with a whip',
  },
  {
    id: 'silent_and_merciless',
    title: 'Silent and merciless',
  },
];
